import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} - Torox Games`;
    } else {
      document.title = `Torox Games — Elder House`;
    }
  }, [title]);
};
